/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inpage-ad[_ngcontent-%COMP%]{display:flex;padding-bottom:1em;margin:auto;justify-content:center}[_nghost-%COMP%]{width:100%}"];
export { styles as styles };
